var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "api类型",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "apiType"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入api类型" },
                            model: {
                              value: _vm.model.apiType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "apiType", $$v)
                              },
                              expression: "model.apiType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "操作用户账号",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "userid"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入操作用户账号" },
                            model: {
                              value: _vm.model.userid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "userid", $$v)
                              },
                              expression: "model.userid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "操作用户名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "username"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入操作用户名称" },
                            model: {
                              value: _vm.model.username,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "username", $$v)
                              },
                              expression: "model.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "问题",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "requestParam"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: { rows: "4", placeholder: "请输入问题" },
                            model: {
                              value: _vm.model.query,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "query", $$v)
                              },
                              expression: "model.query"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "耗时",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "costTime"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入耗时" },
                            model: {
                              value: _vm.model.costTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "costTime", $$v)
                              },
                              expression: "model.costTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "回答",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "responseResult"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: { rows: "10", placeholder: "请输入回答" },
                            model: {
                              value: _vm.model.answer,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "answer", $$v)
                              },
                              expression: "model.answer"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }